import i18n from '@/plugins/i18n'
import { PrefixTranslationsEnum } from '@/common/types/i18n'
import { isNumberStrict, isNumeric } from '@/common/helpers/strings'

const { t } = i18n.global
export const FIELD_MUST_BE_NUMBER_KEY = `${PrefixTranslationsEnum.VEEVALIDATE}.must_be_number`
export const FIELD_REQUIRED_KEY = `${PrefixTranslationsEnum.VEEVALIDATE}.custom_required`
export const FIELD_MAXLENGTH_KEY = `${PrefixTranslationsEnum.VEEVALIDATE}.custom_maxLength`

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function requiredFieldRule(v: any): string | true {
  return (!!v && v.trim().length > 0) || t(FIELD_REQUIRED_KEY)
}

export function mustBeUnderOrEqualMaxLength(v: string, maxLength: number) {
  return v.length > maxLength ? t(FIELD_MAXLENGTH_KEY, { maxLength: maxLength.toString() }) : ''
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mustBeNumericRule(v: any): string | true {
  if (Array.isArray(v)) {
    return v.every(isNumeric) || t(FIELD_MUST_BE_NUMBER_KEY)
  }
  return isNumeric(v) || t(FIELD_MUST_BE_NUMBER_KEY)
}

export const entityCodeRule = (value: string) => {
  return /^[a-zA-Z0-9-_]+$/.test(value)
}

export const numberRule = (value: unknown, [allowEmpty]: [boolean] = [false]) => {
  if (allowEmpty && (value === null || value === undefined || value === '')) return true

  if (typeof value === 'number') return true

  if (Array.isArray(value)) {
    return value.every((v) => typeof v === 'number' || isNumberStrict(String(v)))
  }
  return isNumberStrict(String(value))
}
